import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusPointofContactInnerview } from '@rhybus/point-of-contact'
import { RhyBusInputText } from '@rhybus/form-controls'
import { ChangeEvent, useEffect, useState } from 'react'
import { getPOCData } from '../../services/pointsofcontact'
import type { I_PointOfContact } from '../../interfaces'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'

export default function PointsOfContact() {
    const [searchValue, setSearchValue] = useState('')
    const [pocItems, setPocItems] = useState<I_PointOfContact[]>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        getPOCData().then(setPocItems).finally(() => setIsLoading(false))
    }, [])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }
    return (
        <main id="main-content">
            {isLoading && <PageOverlay />}
            <RhyBusPageHeader
                pageTitle={'Points of Contact'}
                badgeCount={pocItems.length}
                pageHeaderIcon="icon-rb-user-book"
                headerRightContent={
                    <div className="d-flex align-items-center justify-content-end">
                        <label htmlFor="poc-search" className="sr-only">Search points of contact</label>
                        <RhyBusInputText
                            id="poc-search"
                            type='search'
                            iconRight={true}
                            wrapperClassName='min-w-250'
                            customIcon="icon-rb-search"
                            placeholder="Search Points of Contact"
                            value={searchValue}
                            onChange={handleChange}
                        />
                    </div>
                }
            />
            <div className="container">
                <div className='row'>
                    <div className='col-12 mt-0'>
                        <RhyBusPointofContactInnerview
                            pocData={pocItems}
                            showArchivedItems={false}
                            searchQuery={searchValue}
                            pocIconClassName="icon-rb-poc font-20 font-lg-30"
                        />
                    </div>
                </div>
            </div>
        </main>
    )
}